import { useLocation } from 'react-router-dom';
import { useAccount } from '../../contexts/AccountContext';
import { shopLabels } from '../../data/shopLabels';
import { Header } from './Header';
import { Footer } from './Footer';
import { AccountHeader } from './AccountHeader';
import { AccountFooter } from './AccountFooter';
import { MobileActionBar } from './MobileActionBar';
import { AnimatedRoutes } from './AnimatedRoutes';
import { LazyOverlays } from './LazyOverlays';

/**
 * De pagina zelf. Binnen Mijn omgeving (ingelogd, geen herstellink open) een rustige balk en een
 * korte footer; op inloggen en de rest van de site de gewone winkelheader en footer.
 */
export function SiteFrame() {
  const {
    pathname
  } = useLocation();
  const {
    signedIn,
    resetToken
  } = useAccount();
  const portal = signedIn && resetToken === null && (pathname === '/account' || pathname.startsWith('/account/'));
  return (
    /* Vangnet zoals in het beheer: niets mag de pagina breder maken dan het scherm. `clip` en niet `hidden`, zodat sticky blijft werken.
       `relative`: zo knipt dit vak ook absoluut geplaatste onderdelen bij, die anders langs de rand ontsnappen. */
    <div className="relative flex min-h-screen min-h-dvh w-full max-w-[100vw] flex-col overflow-x-clip bg-sand" data-id="element-7938" data-mp="kf5fyfy3sljf">
      {/* Eerste Tab-stop: in één keer voorbij de navigatie. */}
      <a href="#inhoud" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-skip focus:inline-flex focus:min-h-[44px] focus:items-center focus:rounded-full focus:bg-ink focus:px-5 focus:text-[14px] focus:text-shell" data-id="element-7939" data-mp="ajllzz33nwxb">
        {shopLabels.skipToContent}
      </a>
      {portal ? <AccountHeader data-id="element-7940" data-mp="y6jzcnvxaor0" /> : <Header data-id="element-7941" data-mp="ya7svn1dbb5q" />}
      <main id="inhoud" tabIndex={-1} className="flex-1 outline-none" data-id="element-7942" data-mp="u6jkj24wwbjf">
        <AnimatedRoutes data-id="element-7943" data-mp="u69r14knrm8z" />
      </main>
      {portal ? <AccountFooter data-id="element-7944" data-mp="3iyvlczfluo1e" /> : <Footer data-id="element-7945" data-mp="3izezs661quao" />}
      {/* Na de footer: reserveert ook de ruimte onder de vaste balken op mobiel. */}
      <MobileActionBar data-id="element-7946" data-mp="3evz7fm10fg3s" />
      <LazyOverlays data-id="element-7947" data-mp="3evh302471vks" />
    </div>
  );
}